import { render } from "./Terms.vue?vue&type=template&id=57883924&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=57883924&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57883924"

export default script